import styled from '@emotion/styled';
import { Flex } from '@workday/canvas-kit-react/layout';
import { system } from '@workday/canvas-tokens-web';
import * as React from 'react';
import { useContext, useState } from 'react';
import { ConfirmModalOptions, PopupContext } from '.';
import { Canvas } from '../../Canvas';

const ConfirmationPopupContent: React.FC<ConfirmModalOptions & { message: React.ReactNode }> = (props) => {
  const [disabled, setDisabled] = useState(!!props.checkboxConfirmText);
  const popupContext = useContext(PopupContext);
  const toggleDisabled = () => setDisabled((d) => !d);

  const onConfirm = () => {
    popupContext.closeAll();
    props.onConfirm();
  };

  const confirmButtonLabel = props.customConfirmText || 'Confirm';
  const ConfirmButton = props.destructive ? Canvas.DeleteButton : Canvas.PrimaryButton;

  return (
    <>
      <Canvas.Modal.Body>
        <Message>{props.message}</Message>
        {props.checkboxConfirmText && (
          <StyledCheckbox>
            <Canvas.Checkbox checked={!disabled} label={props.checkboxConfirmText} onChange={toggleDisabled} />
          </StyledCheckbox>
        )}
      </Canvas.Modal.Body>
      <Flex gap={system.space.x4} marginTop={system.space.x8} padding={system.space.x2}>
        <ConfirmButton disabled={disabled} onClick={onConfirm} data-cy='confirm-button' data-testid='confirm-button'>
          {confirmButtonLabel}
        </ConfirmButton>
        <Canvas.Modal.CloseButton onClick={props.onCancel}>Cancel</Canvas.Modal.CloseButton>
      </Flex>
    </>
  );
};

const StyledCheckbox = styled.div`
  display: flex;
`;

const Message = styled.div`
  text-align: left;
`;

export default ConfirmationPopupContent;
